var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.containerComponent,{tag:"component",class:['app-scrollbar-container', _vm.themeClassName],style:({ ..._vm.trackCustomMargins })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }